var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Hook for fetching the form configuration for a record type — the
 * **compiled Effective Form Config (EFC)**, not the raw stored template.
 *
 * <b>Why the EFC and not `module-settings/form_config.{TYPE}` (CZNA-431):</b>
 * the ontology is the base and the template is only a delta over it. The raw
 * template deliberately no longer repeats what the ontology already states —
 * CZNA-419 removed 310 duplicated labels precisely because
 * `FormConfigCompiler.fillInLabel` supplies them from the semantic catalog.
 * That fill-in happens when the EFC is compiled, so a form reading the raw
 * template saw no label at all: 81 nodes in personal.json, 69 in corporate,
 * 75 in meeting and 31 in subject carry neither `label` nor `labelKey`, and
 * `renderer/labelResolver.ts` has no catalog lookup. Fields rendered blank.
 * `effective/{TYPE}` = merge(catalog, SCR, template.delta) — CZNA-370 + WP-P5.
 *
 * Behaviour (CZNA-1292 — no bundled fallback):
 * - HTTP 200 with `tabs` → `{ config: <the EFC>, source: 'backend' }`.
 * - HTTP 404 / 403 / 5xx / network error, or a 200 that carries no `tabs` →
 *   `{ config: null, isError: true, source: 'unavailable', failureReason }`
 *   and one `console.warn` with the discriminator. `ProposalForm` renders
 *   `FormConfigUnavailable` (an explicit error with „Zkusit znovu"), the
 *   same screen every type without a bundled template already got.
 * - While the first fetch is in flight → `{ config: null, isLoading: true }`.
 *
 * <b>Why the bundled TS registry is no longer consulted (CZNA-1292).</b> Until
 * this ticket a failed fetch returned `formConfigRegistry.getFormConfig()` for
 * PERSONAL / CORPORATE / MEETING with `isError: false`, so the form rendered
 * identically from a template the tenant never configured — and only the types
 * without a bundled template showed an error. That is how F1 of CZNA-1287 (a
 * 403 on this endpoint for cataloguer and supervisor) survived: a person's form
 * opened on the packaged template without any sign, the subject heading's form
 * did not open at all. A cataloguer who does not know they are looking at a
 * different form than the tenant set cannot report it. The registry and its
 * TS configs still exist (removing them is a separate decision); this hook
 * just never hands them to a form.
 *
 * Cache policy (per ADR-0005 D6):
 * - `staleTime: 5 minutes`, `refetchOnWindowFocus: true`
 * - `retry: false` — 4xx is meaningful state, not a transient failure;
 *   5xx callers can rerender by remount.
 *
 * MEMORY rule: `useOkapiKy()` returns an unstable reference. The ky
 * instance is captured in the query function closure and is NEVER listed
 * in any dependency array — listing it triggers an infinite refetch loop.
 *
 * Export `effectiveFormConfigQueryKey` so the Settings UI can invalidate the
 * compiled result after Save — it does so through
 * `moduleSettingInvalidationKeys` (`./useModuleSetting`), which returns this
 * key alongside the raw template's.
 */
import { useOkapiKy } from '@folio/stripes/core';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { CZNA_MODULE_SETTINGS_EFFECTIVE_TEMPLATE } from '../types/apiPaths';
import { disambiguateFieldIds } from '../components/ProposalForm/config/disambiguateFieldIds';
/**
 * Stable query-key factory for the COMPILED EFC.
 *
 * <b>CZNA-342 — why this is not the raw template's key.</b> Until this ticket
 * the hook keyed on `['module-setting', 'form_config.{TYPE}']`, the exact key
 * `useModuleSetting` uses for the Settings editor. That was sound while both
 * hooks fetched the same endpoint; CZNA-431 repointed this one at
 * `effective/{TYPE}`, whose body is the EFC document itself, while the editor
 * kept reading the raw template behind a `{key, value, customized,
 * optimisticLock, …}` envelope. One cache slot, two incompatible payloads —
 * whichever hook fetched last won, and when the envelope won this hook saw no
 * `tabs` and silently rendered the bundled TS default in place of NK's saved
 * form. Different resource ⇒ different key.
 *
 * Invalidation still has to reach both: saving the template invalidates the
 * compiled result too. That is now explicit — see
 * `moduleSettingInvalidationKeys` in `./useModuleSetting`, which every write
 * path calls. Do not re-merge the two keys to get it back.
 */
export var effectiveFormConfigQueryKey = function (recordType, templateId) { return (templateId === undefined
    ? ['module-setting', 'effective', recordType]
    : ['module-setting', 'effective', recordType, templateId]); };
/** Marker thrown from the query fn so `onError` knows the discriminator. */
var FormConfigFetchError = /** @class */ (function (_super) {
    __extends(FormConfigFetchError, _super);
    function FormConfigFetchError(reason, cause) {
        var _this = _super.call(this, "useFormConfig fetch failed: ".concat(reason)) || this;
        _this.name = 'FormConfigFetchError';
        _this.reason = reason;
        // Attach the original cause for debugging; not used by the hook itself.
        if (cause !== undefined) {
            _this.cause = cause;
        }
        return _this;
    }
    return FormConfigFetchError;
}(Error));
/**
 * Classify a thrown error from `ky.get(...)`. ky throws `HTTPError`
 * (`error.response.status`) for non-2xx; everything else is a network /
 * parse failure.
 *
 * Exported for unit testing — not part of the hook's public surface.
 */
export var classifyError = function (err) {
    var _a;
    if (err && typeof err === 'object' && 'response' in err) {
        var status_1 = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
        if (status_1 === 404)
            return 'not-found';
        if (status_1 === 403)
            return 'forbidden';
        if (typeof status_1 === 'number' && status_1 >= 500)
            return 'server-error';
        // Other HTTP errors (401 / 408 / 409 / 422 / …) — fold into
        // server-error so the discriminator stays a faithful "HTTP responded
        // with non-2xx" rather than mis-labelling a real auth/conflict
        // response as a network failure.
        if (typeof status_1 === 'number' && status_1 >= 400)
            return 'server-error';
    }
    return 'network';
};
/**
 * CZNA-715 — no two fields may share a form-state slot.
 *
 * Applied here rather than in the renderer because `stateKey` is read by the save path
 * and the MARC preview as well: normalizing once, where the config enters, is
 * what keeps those three readers agreeing on which slot belongs to which field.
 * `disambiguateFieldIds` returns its argument unchanged when there is nothing to
 * fix, so for a well-formed config the memo below is handing back the very object
 * react-query cached. The memo is there for the other case: a config that DOES
 * need repairing is rebuilt, and rebuilding it on every render would hand
 * `RecordForm` a new `config` prop each time.
 *
 * See `disambiguateFieldIds.ts` for what a collapsed slot does to the form.
 */
var normalize = function (config) { return (config ? disambiguateFieldIds(config) : null); };
/** The one shape every unresolvable config takes — see the top of this file. */
var unavailable = function (failureReason) { return ({
    config: null,
    isLoading: false,
    isError: true,
    source: 'unavailable',
    failureReason: failureReason,
}); };
/**
 * @param recordType the authority type whose form to compile
 * @param templateId CZNA-456 — which NAMED template of that type to compile.
 *   Omit it and the hook behaves exactly as it always has: it calls
 *   `effective/{type}`, which the backend resolves to the type's DEFAULT
 *   (= complete) template, under the unchanged cache key. That is what every
 *   pre-CZNA-456 caller does and what EDIT paths must keep doing — the NK
 *   meeting of 2026-08-04 decided a simplified template is for CREATION only,
 *   and every later view of the record shows the complete form. Passing a
 *   templateId is therefore a create-time affordance, not a record property;
 *   nothing about the chosen template is stored on the record.
 */
var useFormConfig = function (recordType, templateId) {
    // Closure-capture only. MEMORY: ky is unstable — never in deps.
    var ky = useOkapiKy();
    var _a = useQuery(effectiveFormConfigQueryKey(recordType, templateId), function () { return __awaiter(void 0, void 0, void 0, function () {
        var path, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    path = templateId === undefined
                        ? "czna-authorities/module-settings/effective/".concat(recordType)
                        : CZNA_MODULE_SETTINGS_EFFECTIVE_TEMPLATE(recordType, templateId);
                    return [4 /*yield*/, ky
                            .get(path)
                            .json()];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    err_1 = _a.sent();
                    throw new FormConfigFetchError(classifyError(err_1), err_1);
                case 3: return [2 /*return*/];
            }
        });
    }); }, {
        // API-first (TASK-114): always enabled — the backend decides which types have a form.
        enabled: true,
        staleTime: 5 * 60 * 1000,
        // CZNA-321: the module default `cacheTime: 0` would drop the config between two
        // propose-flow steps and send the next step's form through the loading skeleton,
        // remounting it after it had consumed the parent's restore. Settings saves still
        // invalidate this key (`effectiveFormConfigQueryKey`), so keeping it is safe.
        cacheTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        // 4xx is meaningful state for us. 5xx fall-through is fine — a
        // remount or a successful background refetch will recover.
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    var normalizedData = useMemo(function () { return normalize(data); }, [data]);
    if (isError && error) {
        // Logged from the render path because it is deterministic in tests; the
        // Layer 1 guard (`tests/frontend/tests/formConfigFallbackGuard.ts`) matches
        // this text, and `formConfigFallbackGuard.test.ts` keeps the two in step.
        // eslint-disable-next-line no-console
        console.warn("[useFormConfig] form config for ".concat(recordType, " unavailable: reason=").concat(error.reason));
        return unavailable(error.reason);
    }
    if (data === null || data === void 0 ? void 0 : data.tabs) {
        return {
            config: normalizedData,
            isLoading: false,
            isError: false,
            source: 'backend',
        };
    }
    // Data arrived but carries no `tabs`. Not a fetch failure, so the branch
    // above never fires — and before CZNA-342 this returned the bundled default
    // with no log line anywhere, which is why the cache collision went five
    // weeks without a diagnosis. A 200 that cannot be rendered is a contract
    // breach: the same error as a failed fetch, with its own discriminator.
    if (data !== undefined) {
        // eslint-disable-next-line no-console
        console.warn("[useFormConfig] form config for ".concat(recordType, " unavailable: reason=invalid-payload ")
            + "(HTTP 200 without 'tabs' — a payload-shape mismatch, not a network failure)");
        return unavailable('invalid-payload');
    }
    // First fetch in flight (`data === undefined` without an error).
    return {
        config: null,
        isLoading: isLoading,
        isError: false,
        source: 'loading',
    };
};
export default useFormConfig;
